import SectionHead from "@/components/SectionHead";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLang } from "@/i18n";

const Faq = () => {
  const t = useLang().t;
  return (
  <section data-testid="faq" className="bg-[#FDFBF7] py-16 sm:py-24">
    <div className="container-site">
      <SectionHead
        testId="faq-head"
        eyebrow={t.faq.eyebrow}
        title={t.faq.title}
        sub={t.faq.sub}
      />
      <div className="mx-auto mt-12 max-w-3xl">
        <Accordion type="single" collapsible data-testid="faq-accordion">
          {t.faq.items.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`} className="border-b border-[#EFEBE4]">
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left font-heading text-base sm:text-lg font-semibold text-[#3E2723] hover:text-[#A88667] hover:no-underline py-5"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-content-${i}`} className="text-sm sm:text-base leading-relaxed text-[#5D4037]">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </section>
  );
};

export default Faq;
